//@ts-nocheck
import React, { useEffect } from 'react';
import styled from "styled-components";
import * as d3 from 'd3';
import { gray, blue, green, orange, other, deleteECRReportImage, exportECRChart, filterECRHeading_AndComparison, compareMeasure, createStackedChart_NoComparison, createStackedChart_Comparison } from "./elements/helpers";
import { Heading3, ReportText } from '../../Common/SharedStyledComponents';


const PublicationChart = ({
    pubData,
    pubData_2,
    parentWidth,
    EarlyCareerReportState,
    report_display_id,
    currentDateTime,
    university,
    start_year,
    end_year,
    vintage
}) => {
    useEffect(() => {
        d3.select("#PublicationChart svg").remove();
        d3.select("#PublicationChart .ecr_tooltip").remove();
        deleteECRReportImage("publication-chart.png", currentDateTime, report_display_id, vintage);

        //console.log(pubData);
        //console.log(pubData_2);
        const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);

        if ((compare_measure == 0 && pubData && pubData.length > 0) ||
            (compare_measure > 0 && pubData && pubData_2 && pubData.length > 0 && pubData_2.length > 0)) {
            const subgroups = ["high", "not_high"];
            const colors = [green, blue]
            //is compare on
            if (compare_measure == 0) {
                createStackedChart_NoComparison(
                    "#PublicationChart",
                    parentWidth,
                    pubData,
                    subgroups,
                    "impact",
                    "average_count",
                    "Publications",
                    colors
                );
            }
            else {
                if (pubData_2 && pubData_2.length > 0) {
                    createStackedChart_Comparison(
                        "#PublicationChart",
                        parentWidth,
                        pubData,
                        pubData_2,
                        compare_measure,
                        subgroups,
                        "impact",
                        "average_count",
                        "Publications",
                        colors
                    );
                }
            }
            exportECRChart("#PublicationChart", "publication-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "no", vintage)
        }
    }, [pubData, pubData_2, parentWidth])
    //console.log(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);
    const subHeading = filterECRHeading_AndComparison(EarlyCareerReportState.EarlyCareerReportFilterSavedValues, EarlyCareerReportState.Suborgs);
    const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);

    if (compare_measure > 0) {
        //need both awardCount and pubData_2 to have at least one value per year

        const years = ['1', '2', '3', '4', '5', '6', '7', '8'];
        const filtered1 = pubData?.filter(function (item) {
            return years.includes(item.t_emp);
        })
        const filtered2 = pubData_2?.filter(function (item) {
            return years.includes(item.t_emp);
        })

        //console.log(filtered1)
        //console.log(filtered2)
    }

    return (
        <div className="ChartComponent">
            <div style={{ clear: "both"}} id="PublicationChart_ForExport">
                <Heading3 bold italic style={{ clear: "both"}}>Publications, {university} Faculty</Heading3>
                <Heading3 italic>{subHeading}</Heading3>
                <div id="PublicationChart"></div>
                {(pubData?.length == 0 || (compare_measure > 0 && (pubData?.length == 0 || pubData_2?.length == 0))) && <p className="no_data_text">Due to the small number of results and the potential for disclosure of personal information, this chart cannot be displayed. Please select a larger group.</p>}
                <ReportText>
                    This chart shows the average number of publications per faculty member funded on sponsored projects, and whether those publications are in high impact journals. "High Impact" refers to publications in journals with an impact factor of 10 or higher. "Data Year" refers to the number of years a cohort of faculty members has appeared in the IRIS-UMETRICS dataset of researchers paid on sponsored grants. Data from {start_year} to {end_year} were used to build these cohorts.
                </ReportText>
            </div>
            <a className="export" onClick={() => exportECRChart("#PublicationChart_ForExport", "publication-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "yes", vintage)}><i className="fa fas fa-download ecr_export"></i>Export Chart</a>
        </div>
    );
}

/**
 * Styled div to shrink graph titles
 * */
export const TitleDiv = styled.div`
    width: 75%;
    margin-inline: auto;
`;

export default PublicationChart;